import _ from "lodash";
import { api, getRequest, putRequest } from "../../server/request";
import { handleError, handleResponse, handleResponseObj } from "../../actions/responseUtil";
import { ServiceAccount } from "./types";
import { KAPTUREV2_URL_INV } from "../../config";
import axios, { Method } from 'axios';
import ServiceLines from "./ServiceLines";
import { toast } from "react-toastify";
import { getDataFromLocalStorage } from "../../utils/util";
import { LOGGED_IN_USER } from "../../constants/Constants";

const _authorizationHeaders = () => {
    const loggedInUser = getDataFromLocalStorage(LOGGED_IN_USER);
    const token = loggedInUser ? JSON.parse(loggedInUser)?.data.id_token : '';

    return {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : '',
    };
};

export const ACTION_TYPES = {
    SET_LOADING: "starlinkAdmin/setLoading",
    SET_TOPUP_LOADING: "starlinkAdmin/setTopUpLoading",
    GET_SERVICE_ACCOUNTS: "starlinkAdmin/getServiceAccounts",
    GET_V2_SERVICE_ACCOUNTS: "starlinkAdmin/getV2ServiceAccounts",
    CREATING_SERVICE_ACCOUNT: "starlinkAdmin/CreatingServicceAccount",
    CREATE_V2_SERVICE_ACCOUNT: "starlinkAdmin/createV2ServiceAccount",
    UPDATING_V2_SERVICE_ACCOUNT: "starlikAdmin/UpdatingV2ServiceAccount",
    UPDATE_V2_SERVICE_ACCOUNT: "starlinkAdmin/UpdateV2ServiceAccount",
    DELETING_V2_SERVICE_ACCOUNT: "starlinkAdmin/deletingV2ServiceAccount",
    DELETE_V2_SERVICE_ACCOUNT: "starlinkAdmin/deleteV2ServiceAccount",
    GET_SERVICE_LINES: "starlinkAdmin/getServiceLines",
    GET_USER_TERMINALS: "starlinkAdmin/getUserTerminals",
    GET_STARLINK_AUDIT_LOGS: "starlinkAdmin/getStarlinkAuditLogs",
    GET_ALL_SERVICE_LINES_BY_CREDENTIAL: "starlinkAdmin/getAllServiceLinesByCredential",
    GET_SERVICE_LINES_SUBSCRIPTIONS: "starlinkAdmin/getServiceLineSubscription",
    GET_AVAILABLE_PRODUCTS_FOR_ACCOUNT: "starlinkAdmin/getAvailableProductsForAccount",
    GET_OPTIN_SERVICE_LINE: 'starlinkAdmin/getOptinServiceLine',
    GET_ORGANIZATION_LIST:'starlinkAdmin/getOrganizationList',
    GET_CUSTOM_PLANS:'starlinkAdmin/getCustomPlans',
    GET_STARLINK_PARENT_POOL_LIST:"starlinkAdmin/getStarLinkParentPoolList",
    GET_CUSTOM_PLAN_PER_DP: "starlinkAdmin/getCustomPlanPerDP",
    GET_SUBSCRIPTION_FOR_ACCOUNT: "starlinkAdmin/getSubscriptionForAccount",
    UPDATE_SERVICE_LINE_DETAILS: "starlinkAdmin/updateServiceLineDetails",
    SYNC_SERVICE_ACCOUNTS: "starlinkAdmin/syncServiceAccounts",
    UPDATE_PUBLIC_IP: "starlinkAdmin/updatePublicIP",
    ADD_USER_TERMINAL_TO_SERVICE_LINE: "starlinkAdmin/addUserTerminalToServiceLine",
    REMOVE_USER_TERMINAL_FROM_SERVICE_LINE : "starlinkAdmin/removeUserTerminalFromServiceLine",
    REBOOT_USER_TERMINAL : "starlinkAdmin/rebootUserTerminal",
    ADD_TOPUP_TO_PARENT_POOL:"starlinkAdmin/addTopUpToParentPool",
    ADD_TOPUP_TO_CHILD_POOL:"starlinkAdmin/addTopUpToChildPool",
    ADD_TOPUP_TO_SERVICE_LINE:"starlinkAdmin/addTopUpToServiceLine",
    ADD_TOPUP_TO_STANDARD_SERVICE_LINE: "starlinkAdmin/addTopUpToStandardServiceLine",
    GET_ALL_SITES_WITH_DEVICES: "starlinkAdmin/getAllSitesWithDevices",
    GET_SITE_FOR_TERMINAL: "starlinkAdmin/siteForTerminal",
    ADD_SITE_TO_SERVICE_LINE: "starlinkAdmin/addSiteToServiceLine",
    GET_NON_ADMIN_PERMISSIONS: "starlinkAdmin/getNonAdminPermissions",
    GET_PARENT_DP: "/starlinkAdmin/getParentDP",
    UPDATE_NON_ADMIN_PERMISSIONS: "/starlinkAdmin/updateNonAdminPermissions",
    GET_SERVICE_LINES_FOR_SUBSCRIPTION: "starlinkAdmin/getServiceLinesForSubscription",
    SUBSCRIBE_SERVICE_LINES: "starlinkAdmin/subscribeServiceLines",
    GET_TOP_UP_PRODUCTS: "starlinkAdmin/getTopUpProducts",
    ASSIGN_CUSTOM_PLAN: "starlinkAdmin/assignCustomPlan",
    CANCEL_SCHEDULED_PLAN: "starlinkAdmin/cancelScheduledPlan",
    GET_ROUTERS_PER_TERMINAL: "starlinkAdmin/getRoutersPerTerminal",
    GET_SERVICELINE_TERMINAL_ROUTER: "starlinkAdmin/getServicelineTerminalRouter",
    APPLY_ROUTER_CONFIG: "starlinkAdmin/applyRouterConfig",
    ASSIGN_ROUTER_CONFIG: "starlinkAdmin/routerConfigAssign",
    CREATE_PARENT_POOL: "starlinkAdmin/createParentPool",
    UPDATE_PARENT_POOL: "starlinkAdmin/updateParentPool",
    ADD_KIT_TO_WAREHOUSE: "starlinkAdmin/addKitToWarehouse",
    REMOVE_USER_TERMINAL: "starlinkAdmin/remove_user_terminal",
    GET_ROUTER_CONFIG: "starlinkAdmin/getRouterConfig",
    GET_ROUTER_CONFIGS: "starlinkAdmin/getRouterConfigs",
    REBOOT_ROUTER: "starlinkAdmin/rebootAdmin",
    VALIDATE_ROUTER_CONFIG: "starlinkAdmin/validateRouterConfig",
    UPDATE_ROUTER_CONFIGURATION: "starlinkAdmin/updateRouterConfiguration",
    CREATE_ROUTER_CONFIG: "starlinkAdmin/createRouterCOnfiguration",
    GET_USER_TERMINALS_FOR_ASSIGN: "starlinkAdmin/getUserTerminalsForAssign",
    ASSIGN_USER_TERMINAL_TO_SUBORG: "starlinkAdmin/assignUserTerminalToSubOrg",
    GET_DPO_ACCOUNT: "starlinkAdmin/getDpoAccount",
    GET_DPO_PRODUCTS: "starlinkAdmin/getDpoProducts",
    DELETE_DPO_Account: "starlinkAdmin/deleteDpoAccount",
    INITIATE_DPO_PAYMENT: "starlinkAdmin/initiateDpoPayment",
    GET_DPO_PAYMENT_STATUS: "starlinkAdmin/getDpoPaymentStatus",
    GET_STARLINK_VALID_DPO_DPS: "starlinkAdmin/getStarlinkValidDpoDps",
    GET_VERIFY_DPO_ACCOUNT: "starlinkAdmin/getVerifyDPOAccount",
    GET_DPO_ACCOUNT_INFO: "starlinkAdmin/getDpoAccountInfo",
    CANCEL_DPO_TRANSACTION: "starlinkAdmin/cancelDpoTransaction",
    GET_ROUTER_CONFIG_VISIBILITY: "starlinkAdmin/getRouterConfigVisibility",
    SET_ROUTER_CONFIG_VISIBILITY: "starlinkAdmin/setRouterConfigVisibility"
}

const initialState = {
    serviceAccounts: [],
    totalServiceAccounts: 0,
    gettingServiceAccounts: false,
    v2ServiceAccounts: [],
    totalV2ServiceAccounts: 0,
    gettingV2ServiceAccounts: false,
    creatingServiceAccount: false,
    creatingParentPool: false,
    updatingParentPool: false,
    v2ServiceAccount: {},
    updatedV2ServiceAccount: {},
    creatingV2ServiceAccount: false,
    syncingServiceAccount: false,
    addingUTtoServiceLine:false,
    addingSiteToServiceLine:false,
    addingTopup:false,
    removeUTfromServiceLine:false,
    rebootingUserTerminal:false,
    updatingServiceAccount: false,
    updatingV2ServiceAccount: false,
    deletingServiceAccount: false,
    deletingV2ServiceAccount: false,
    deletedServiceAccount: {},
    serviceLines: [],
    allServiceLines: [],
    totalServiceLines: 0,
    gettingServiceLines: false,
    updatingServiceLine: false,
    addingKitToWareHouse: false,
    userTerminals: [],
    totalUserTerminals: 0,
    auditLogs:[],
    totalAuditLogs:0,
    gettingUserTerminals: false,
    subcribingServiceLine:false,
    updatingNonAdminPermissions: false,
    gettingNonAdminPermissions:false,
    allNonAdminPermissions: [],
    parentDp:[],
    updateNonAdmin:[],
    allServiceLinesSubscription:[],
    availableProductsForAccount:[],
    optInServiceLineRes: {},
    creatingSubPool:false,
    organizationList:[],
    organizationListCount:0,
    customPlansCount:0,
    customPlansList:[],
    parentPoolList:[],
    allCustomPlansPerDP: [],
    subscriptionsForAccount:[],
    updateServiceLineDetail:{},
    syncServiceAccountDetail: {},
    updatePublicIP:{},
    addUserTerminalToServiceLine:{},
    addTopUpToParentPool:{},
    addTopUpToChildPool:{},
    addTopUpToServiceLine:{},
    addTopUpToStandardServiceLine: {},
    assignCustomplan:{},
    addKitToWareHouseRes:{},
    removeUserTerminalFromServiceLine:{},
    rebootUserTerminal:{},
    sitesWithDevices: [],
    siteForTerminal:{},
    addSiteToServiceLine:{},
    serviceLinesForSubscription:[],
    totalServiceLinesForSubscription: 0,
    subscribeServiceLines: {},
    unsubscribedSLs:0,
    subscribedSLs:0,
    standardTopUpProducts: [],
    routersOnTerminal:[],
    gettingTerminalRouter: false,
    servicelineTerminalRouters: [],
    gettingServicelineTerminalRouter: false,
    updatingRouterConfig: false,
    assigningRouterConfig: false,
    gettingRouterConfig: false,
    routerConfig: [],
    gettingRouterConfigs: false,
    routerConfigs: [],
    rebootingRouter: false,
    rebootRouter: [],
    applyRouterConfig: null,
    routerConfigAssign: [],
    validatingRouterConfig: false,
    routerConfigValidate: [],
    updatingRouterConfiguration: false,
    routerConfigurationUpdate: [],
    createParentPoolData:[],
    updateParentPoolData: [],
    removingUserTerminal:false,
    removeUserTerminal: null,
    creatingRouterConfig: false,
    createNewRouterConfig: [],
    userTerminalsForAssign: [],
    totalAssignUserTerminals: [],
    moveUserTerminalsLoading:false,
    moveUserTerminal: [],
    creatingDPOAccount:false,
    updatingDPOAccount:false,
    gettingDPOAccount:false,
    dpoAccountInfo: [],
    dpoProducts: [],
    deleteDpoAccount: [],
    inititeDpoPaymentInfo: [],
    dpoPaymentStatus: [],
    isValidDpForDPO: false,
    dpoVerificationStatus: {},
    getDpoAccountInfo: [],
    cancelTransaction: [],
    routerConfigVisibility: 'enabled',
    gettingRouterConfigVisibility: false,
    settingRouterConfigVisibility: false

}

export function starlinkAdminReducer(state: any = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.GET_SERVICE_ACCOUNTS: {
            const [serviceAccounts, totalServiceAccounts] = action.payload?.data?.rows.length > 0 ?  action.payload?.data?.rows[0] : [];
            return {
                ...state,
                serviceAccounts: serviceAccounts || [],
                totalServiceAccounts: totalServiceAccounts ? totalServiceAccounts : 0,
            }
        }
        case ACTION_TYPES.GET_V2_SERVICE_ACCOUNTS: {
            return{
                ...state,
                v2ServiceAccounts: action.payload?.data || [],
                totalV2ServiceAccounts: action.payload?.data?.[0]?.totalCount || 0,
            }
        }
        case ACTION_TYPES.CREATING_SERVICE_ACCOUNT: {
            return {
                ...state,
                creatingV2ServiceAccount: action.payload
            }
        }
        case ACTION_TYPES.CREATE_V2_SERVICE_ACCOUNT: {
            return {
                ...state,
                v2ServiceAccount: action.payload,
                creatingV2ServiceAccount: false
            }
        }
        case ACTION_TYPES.UPDATING_V2_SERVICE_ACCOUNT: {
            return {
                ...state,
                updatingV2ServiceAccount: action.payload
            }
        }
        case ACTION_TYPES.UPDATE_V2_SERVICE_ACCOUNT: {
            return {
                ...state,
                updatedV2ServiceAccount: action.payload,
                updatingV2ServiceAccount: false
            }
        }
        case ACTION_TYPES.DELETING_V2_SERVICE_ACCOUNT: {
            return {
                ...state,
                deletingV2ServiceAccount: action.payload
            }
        }
        case ACTION_TYPES.DELETE_V2_SERVICE_ACCOUNT: {
            return {
                ...state,
                deletedServiceAccount: action.payload,
                deletingV2ServiceAccount: false
            }
        }
        case ACTION_TYPES.GET_SERVICE_LINES: {
            const [serviceLines, totalServiceLines] = action.payload?.data?.rows.length > 0 ? action.payload?.data?.rows[0] : [];
            return {
                ...state,
                serviceLines: serviceLines || [],
                totalServiceLines: totalServiceLines ? totalServiceLines : 0,
            }
        }
        case ACTION_TYPES.GET_SERVICE_LINES_FOR_SUBSCRIPTION: {
            const [serviceLines, totalServiceLines, subscribed,  unsubscribed] = action.payload?.data?.rows.length > 0 ? action.payload?.data?.rows[0] : [];
            return {
                ...state,
                serviceLinesForSubscription: serviceLines || [],
                totalServiceLinesForSubscription: totalServiceLines ? totalServiceLines : 0,
                unsubscribedSLs:unsubscribed ? unsubscribed : 0,
                subscribedSLs:subscribed ? subscribed : 0 
            }
        }
        case ACTION_TYPES.GET_AVAILABLE_PRODUCTS_FOR_ACCOUNT: {
            return {
                ...state,
                availableProductsForAccount: action.payload?.data?.rows,
            }
        }
        case ACTION_TYPES.GET_CUSTOM_PLANS: {
            return {
                ...state,
                customPlansList: action.payload?.data?.rows && action.payload?.data?.rows.length > 0 && action.payload?.data?.rows[0] && action.payload?.data?.rows[0].length > 0 ? action.payload?.data?.rows[0][0] : [],
                customPlansCount: action.payload?.data?.rows && action.payload?.data?.rows.length > 0 && action.payload?.data?.rows[0] && action.payload?.data?.rows[0].length > 0 ? action.payload?.data?.rows[0][1] : [],
            }
        }
        case ACTION_TYPES.GET_STARLINK_PARENT_POOL_LIST: {
            return {
                ...state,
                parentPoolList: action.payload?.data?.rows && action.payload?.data?.rows.length > 0 && action.payload?.data?.rows[0] && action.payload?.data?.rows[0].length > 0 ? action.payload?.data?.rows[0][0] : [],
            }
        }
        
        case ACTION_TYPES.GET_ORGANIZATION_LIST: {
            return {
                ...state,
                organizationList: action.payload?.data?.rows && action.payload?.data?.rows.length > 0 && action.payload?.data?.rows[0] && action.payload?.data?.rows[0].length > 0 ? action.payload?.data?.rows[0][0] : [],
                organizationListCount: action.payload?.data?.rows && action.payload?.data?.rows.length > 0 && action.payload?.data?.rows[0] && action.payload?.data?.rows[0].length > 0 ? action.payload?.data?.rows[0][1] : 0,
            }
        }
        case ACTION_TYPES.GET_USER_TERMINALS: {
            const userTerminals = action.payload?.data;
            const totalUserTerminals = action.payload?.data[0]?.total_count;
            return {
                ...state,
                userTerminals: userTerminals || [],
                totalUserTerminals: totalUserTerminals ? totalUserTerminals : 0,
            }
        }
        case ACTION_TYPES.GET_ALL_SITES_WITH_DEVICES: {
            const sitesWithDevices = action.payload?.data;
            return {
                ...state,
                sitesWithDevices: sitesWithDevices || [],
            }
        }
        case ACTION_TYPES.GET_SITE_FOR_TERMINAL: {
            const siteForTerminal = action.payload?.data;
            return {
                ...state,
                siteForTerminal: siteForTerminal || [],
            }
        }
        case ACTION_TYPES.GET_SUBSCRIPTION_FOR_ACCOUNT: {
            const subscriptions = action.payload?.data?.rows &&  action.payload?.data?.rows.length > 0 ?  action.payload?.data?.rows[0][0]: [];
            return {
                ...state,
                subscriptionsForAccount: subscriptions || [],
            }
        }
        case ACTION_TYPES.GET_STARLINK_AUDIT_LOGS: {
            const auditLogs = action.payload?.data[0]?.result;
            const totalAuditLogs = action.payload?.data[0]?.total_count;
            return {
                ...state,
                auditLogs: auditLogs || [],
                totalAuditLogs: totalAuditLogs ? totalAuditLogs : 0,
            }
        }
        
        case ACTION_TYPES.GET_CUSTOM_PLAN_PER_DP: {
            const allCustomPlansPerDP = action.payload?.data?.rows[0][0];
          
            return {
                ...state,
                allCustomPlansPerDP: allCustomPlansPerDP || [],
            }
        }
        case ACTION_TYPES.GET_ALL_SERVICE_LINES_BY_CREDENTIAL: {
            const allServiceLines = JSON.parse(action.payload?.data?.rows[0][0]);
            return {
                ...state,
                allServiceLines: allServiceLines || [],
            }
        }
        case ACTION_TYPES.GET_SERVICE_LINES_SUBSCRIPTIONS: {
            const allServiceLinesSubscription = action.payload || [];
            return {
                ...state,
                allServiceLinesSubscription: allServiceLinesSubscription
            }
        }
        case ACTION_TYPES.GET_NON_ADMIN_PERMISSIONS: {
             const allNonAdminPermissions = action.payload?.data || [];
            return {
                ...state,
                allNonAdminPermissions: allNonAdminPermissions
            }
        }
        case ACTION_TYPES.GET_PARENT_DP: {
            const parentDp = action.payload?.data || [];
           return {
               ...state,
               parentDp: parentDp
            }
        }
        case ACTION_TYPES.UPDATE_NON_ADMIN_PERMISSIONS: {
            const updateNonAdmin = action.payload?.data || [];
            return {
                ...state,
                updateNonAdmin: updateNonAdmin
            }
        }
        case ACTION_TYPES.SET_LOADING: {
            return {
                ...state,
                ...action.payload,
            }
        }
        case ACTION_TYPES.GET_OPTIN_SERVICE_LINE: {
            return {
                ...state,
                optInServiceLineRes: action.payload
            }
        }
         case ACTION_TYPES.REMOVE_USER_TERMINAL: {
            return {
                ...state,
                removeUserTerminal: action.payload
            }
        }
        case ACTION_TYPES.UPDATE_SERVICE_LINE_DETAILS: {
            return {
                ...state,
                updateServiceLineDetail: action.payload
            }
        }
        case ACTION_TYPES.SYNC_SERVICE_ACCOUNTS: {
            return {
                ...state,
                syncServiceAccountDetail: action.payload
            }
        }
        case ACTION_TYPES.UPDATE_PUBLIC_IP: {
            return {
                ...state,
                updatePublicIP: action.payload
            }
        }
         case ACTION_TYPES.CREATE_PARENT_POOL: {
            return {
                ...state,
                createParentPoolData: action.payload
            }
        }
        case ACTION_TYPES.REBOOT_ROUTER: {
            return {
                ...state,
                rebootRouter: action.payload 
            }
        }
        case ACTION_TYPES.CREATE_ROUTER_CONFIG: {
            return {
                ...state,
                createNewRouterConfig: action.payload
            }
        }
        case ACTION_TYPES.VALIDATE_ROUTER_CONFIG: {
            return {
                ...state,
                routerConfigValidate: action.payload
            }
        }
        case ACTION_TYPES.UPDATE_ROUTER_CONFIGURATION: {
            return {
                ...state,
                routerConfigurationUpdate: action.payload
            }
        }
        case ACTION_TYPES.UPDATE_PARENT_POOL: {
            return {
                ...state,
                updateParentPoolData: action.payload
            }
        }
        case ACTION_TYPES.GET_ROUTER_CONFIG: {
            return {
                ...state,
                routerConfig: action.payload
            }
        }
        case ACTION_TYPES.GET_ROUTER_CONFIGS: {
            return {
                ...state,
                routerConfigs: action.payload
            }
        }
        case ACTION_TYPES.ADD_TOPUP_TO_PARENT_POOL: {
            return {
                ...state,
                addTopUpToParentPool: action.payload
            }
        }
        case ACTION_TYPES.ADD_TOPUP_TO_CHILD_POOL: {
            return {
                ...state,
                addTopUpToChildPool: action.payload
            }
        }
        case ACTION_TYPES.ASSIGN_CUSTOM_PLAN: {
            return {
                ...state,
                assignCustomplan: action.payload
            }
        }
          case ACTION_TYPES.ADD_KIT_TO_WAREHOUSE: {
            return {
                ...state,
                addKitToWareHouseRes: action.payload
            }
        }
        case ACTION_TYPES.ADD_TOPUP_TO_STANDARD_SERVICE_LINE: {
            return {
                ...state,
                addTopUpToStandardServiceLine: action.payload
            }
        }
        case ACTION_TYPES.ADD_TOPUP_TO_SERVICE_LINE: {
            return {
                ...state,
                addTopUpToServiceLine: action.payload
            }
        }
        case ACTION_TYPES.ADD_USER_TERMINAL_TO_SERVICE_LINE: {
            return {
                ...state,
                addUserTerminalToServiceLine: action.payload
            }
        }
        case ACTION_TYPES.ADD_SITE_TO_SERVICE_LINE: {
            return {
                ...state,
                addSiteToServiceLine: action.payload
            }
        }
        case ACTION_TYPES.REMOVE_USER_TERMINAL_FROM_SERVICE_LINE: {
            return {
                ...state,
                removeUserTerminalFromServiceLine: action.payload
            }
        }
        case ACTION_TYPES.REBOOT_USER_TERMINAL: {
            return {
                ...state,
                rebootUserTerminal: action.payload
            }
        }
        case ACTION_TYPES.SUBSCRIBE_SERVICE_LINES: {
            return {
                ...state,
                subscribeServiceLines: action.payload
            }
        }
        case ACTION_TYPES.GET_TOP_UP_PRODUCTS: {
            return {
                ...state,
                standardTopUpProducts: action.payload?.data ? action.payload?.data : []
            }
        }
         case ACTION_TYPES.GET_ROUTERS_PER_TERMINAL: {
            return {
                ...state,
                routersOnTerminal: action.payload?.data ? action.payload?.data : []
            }
        }
        case ACTION_TYPES.GET_SERVICELINE_TERMINAL_ROUTER: {
            return {
                ...state,
                servicelineTerminalRouters: action.payload?.data ? action.payload?.data : []
            }
        }
        case ACTION_TYPES.CANCEL_SCHEDULED_PLAN : {
            return {
                ...state,
                scheduledPlan: null
            }
        }
           case ACTION_TYPES.APPLY_ROUTER_CONFIG : {
            return {
                ...state,
                applyRouterConfig: action.payload ? action.payload : []
            }
        }
        case ACTION_TYPES.ASSIGN_ROUTER_CONFIG: {
            return {
                ...state,
                routerConfigAssign: action.payload
            }
        }
        case ACTION_TYPES.GET_USER_TERMINALS_FOR_ASSIGN: {
            const userTerminals = action.payload?.data;
            const totalUserTerminals = action.payload?.data[0]?.total_count;
            return {
                ...state,
                userTerminalsForAssign: userTerminals || [],
                totalAssignUserTerminals: totalUserTerminals ? totalUserTerminals : 0,
            }
        }
        case ACTION_TYPES.ASSIGN_USER_TERMINAL_TO_SUBORG: {
            const moveUserTerminal = action.payload;
            return {
                ...state,
                moveUserTerminal: moveUserTerminal || [],
            }
        }
         case ACTION_TYPES.GET_DPO_ACCOUNT: {
            const account = action.payload?.data || {};
           return {
               ...state,
               dpoAccountInfo: account
            }
        }
         case ACTION_TYPES.GET_DPO_ACCOUNT_INFO: {
            const account = action.payload?.data && action.payload?.data?.length > 0 && action.payload?.data[0] || {};
           return {
               ...state,
               getDpoAccountInfo: account
            }
        }
        case ACTION_TYPES.GET_DPO_PRODUCTS: {
            const products = action.payload?.data || [];
           return {
               ...state,
               dpoProducts: products
            }
        }
        case ACTION_TYPES.DELETE_DPO_Account: {
            const deleteAccount = action.payload?.data || {};
           return {
               ...state,
               deleteDpoAccount: deleteAccount
            }
        }
        case ACTION_TYPES.INITIATE_DPO_PAYMENT: {
            const dpoPayment = action.payload?.data || [];
           return {
               ...state,
               inititeDpoPaymentInfo: dpoPayment
            }
        }
        case ACTION_TYPES.GET_DPO_PAYMENT_STATUS: {
            const dpoPaymentStatus = action.payload?.data || {};
           return {
               ...state,
               dpoPaymentStatus: dpoPaymentStatus
            }
        }
        case ACTION_TYPES.GET_VERIFY_DPO_ACCOUNT: {
            const dpoVerificationStatus = action.payload || {};
           return {
               ...state,
               dpoVerificationStatus: dpoVerificationStatus
            }
        }
         case ACTION_TYPES.GET_STARLINK_VALID_DPO_DPS: {
            const isValid = action.payload?.data && action.payload?.data?.length > 0 ? action.payload?.data[0]?.is_dpo_valid : false || false ;
            return {
                ...state,
                isValidDpForDPO: isValid ,
            }
        }
          case ACTION_TYPES.CANCEL_DPO_TRANSACTION: {
            const cancelTransaction = action.payload || {};
           return {
               ...state,
               cancelTransaction: cancelTransaction
            }
        }
        case ACTION_TYPES.GET_ROUTER_CONFIG_VISIBILITY: {
            const visibility = action.payload?.data?.visibility || 'enabled';
            return {
                ...state,
                routerConfigVisibility: visibility
            }
        }
        case ACTION_TYPES.SET_ROUTER_CONFIG_VISIBILITY: {
            return {
                ...state,
                settingRouterConfigVisibility: false
            }
        }
        default:
            return state
    }
}

export interface getServiceAccountsParameters {
    dpIds: string[];
    searchText: string;
    sortBy: string;
    sortOrder: string;
    page: number;
    limit: number;
}

export const getV2ServiceAccounts = (parameters: getServiceAccountsParameters) => (dispatch) => {
    if (_.isEmpty(parameters?.dpIds)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingV2ServiceAccounts: true } });
    let _parameters: any = {
        dpIds: parameters.dpIds.map(dpId => `'${dpId}'`).join(','),
        searchText: parameters.searchText,
        sortBy: parameters.sortBy,
        sortOrder: parameters.sortOrder,
        limit: parameters.limit,
        offset: (parameters.page - 1) * parameters.limit
    };
    const data = {
        query: `GET_SERVICE_CREDENTIAL_ACCOUNTS`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/pg/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_V2_SERVICE_ACCOUNTS)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingV2ServiceAccounts: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingV2ServiceAccounts: false } });
        });
}

export const createServiceAccount = (parameters, abortSignal: AbortSignal | undefined) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: true } });
    const data = {
        dpId: parameters.dpId,
        type: parameters.type,
        username: parameters.userName,
        password: parameters.password,
        clientId: parameters.clientId,
        clientSecret: parameters.clientSecret,
        validate: parameters.validate,
        assignmentDpId: parameters?.selectedDp?.id || "" 
    }
    
    try {
        let res = await api.starlink.post('/credentials', data, {}, abortSignal)
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: false } });
        return error;
    }
}

export const createV2ServiceAccount = (parameters, abortSignal: AbortSignal | undefined) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.CREATING_SERVICE_ACCOUNT, payload:  true });
    
    try {
        let res = await api.starlink.post('/accounts', parameters, {}, abortSignal)
        dispatch({ type: ACTION_TYPES.CREATING_SERVICE_ACCOUNT, payload: false });
        handleResponseObj(res, dispatch, ACTION_TYPES.CREATE_V2_SERVICE_ACCOUNT);
        showNewToastMessage(res)
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.CREATING_SERVICE_ACCOUNT, payload: false });
        return error;
    }
}

export const createParentPool = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingParentPool: true } });
    const data = {
        organizationId: parameters.dpId,
        accountNumber: parameters.accountNumber,
        credentialId: parameters.credentialId,
        poolName: parameters.poolName,
        poolSize: parameters.poolSize,
        unit: parameters.unit,
        startDate: parameters.startDate,
        endDate: parameters.endDate,
        isRecurring: parameters.isRecurring,
        poolInfo: parameters.poolInfo,
        notificationMethods: [
            "email"
        ],
        usersToNotify: parameters.usersToNotify,
        quotaActions: parameters.quotaActions,
    }
    
    try {
        let res = await api.starlink.post('/parentPools', data, {})
        handleResponseObj(res, dispatch, ACTION_TYPES.CREATE_PARENT_POOL)
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingParentPool: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingParentPool: false } });
        return error;
    }
}

export const updateParentPool = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingParentPool: true } });
    const data = {
        organizationId: parameters.dpId,
        accountNumber: parameters.accountNumber,
        credentialId: parameters.credentialId,
        poolName: parameters.poolName,
        poolSize: parameters.poolSize,
        unit: parameters.unit,
        startDate: parameters.startDate,
        endDate: parameters.endDate,
        isRecurring: parameters.isRecurring,
        poolInfo: parameters.poolInfo,
        notificationMethods: [
            "email"
        ],
        usersToNotify: parameters.usersToNotify,
        quotaActions: parameters.quotaActions,
    }
    
    try {
        let res = await api.starlink.put(`/parentPools/${parameters?.parentPoolId}`, data, {})
        handleResponseObj(res, dispatch, ACTION_TYPES.UPDATE_PARENT_POOL)
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingParentPool: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingParentPool: false } });
        return error;
    }
}

export const createSubPool = ( parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingSubPool: true } });

    const data = {
        credentialId: parameters.credentialId,
        organizationId: parameters.dpId,
        accountNumber: parameters.accountNumber,
        assignedBy: parameters.assignedBy,
        poolName: parameters.poolName,
        poolSize: parameters.poolSize,
        unit: parameters.unit,
        startDate: parameters.startDate,
        duration: parameters.duration,
        isRecurring: parameters.isRecurring,
        poolInfo: parameters.poolInfo,
        notificationMethods: parameters.notificationMethods,
        usersToNotify: parameters.usersToNotify,
        quotaActions: parameters.quotaActions
       
    };
    
    try {
        let res = await api.starlink.post(`/parentPools/${parameters.parentPoolId}/childPools`, data);
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingSubPool: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingSubPool: false } });
        return error;
    }
};

export const updateSubPool = ( parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingSubPool: true } });

    const data = {
        credentialId: parameters.credentialId,
        organizationId: parameters.dpId,
        accountNumber: parameters.accountNumber,
        assignedBy: parameters.assignedBy,
        poolName: parameters.poolName,
        poolSize: parameters.poolSize,
        unit: parameters.unit,
        startDate: parameters.startDate,
        duration: parameters.duration,
        isRecurring: parameters.isRecurring,
        poolInfo: parameters.poolInfo,
        notificationMethods: parameters.notificationMethods,
        usersToNotify: parameters.usersToNotify,
        quotaActions: parameters.quotaActions
       
    };
    
    try {
        let res = await api.starlink.put(`/parentPools/${parameters.parentPoolId}/childPools/${parameters?.childPoolId}`, data);
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingSubPool: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingSubPool: false } });
        return error;
    }
};


// export const updateServiceAccount = (parameters: ServiceAccount) => async (dispatch) => {
//     dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingServiceAccount: true } });
//     const data = {
//         dpId: parameters.dpId,
//         type: parameters.type,
//         username: parameters.userName,
//         password: parameters.password,
//         clientId: parameters.clientId,
//         clientSecret: parameters.clientSecret,
//         assignmentDpId: parameters?.selectedDp?.id
//     }
    
//     try {
//         let res = await api.starlink.put(`/credentials/${parameters.id}`, data)
//         dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingServiceAccount: false } });
//         return res;
//     } catch (error) {
//         dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingServiceAccount: false } });
//         return null;
//     }
// }

export const updateV2ServiceAccount = (parameters: ServiceAccount) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.UPDATING_V2_SERVICE_ACCOUNT, payload: true });
    const data = {
        dpId: parameters.dpId,
        assignmentDpId: parameters.selectedDp,
        clientId: parameters.client_id,
        clientSecret: parameters.clientSecret,
        accountNumber: parameters.accountNumber
    }
    
    try {
        let res = await api.starlink.put(`/accounts/update`, data)
        dispatch({ type: ACTION_TYPES.UPDATING_V2_SERVICE_ACCOUNT, payload: false});
        handleResponseObj(res, dispatch, ACTION_TYPES.UPDATE_V2_SERVICE_ACCOUNT);
        showNewToastMessage(res)
    } catch (error) {
        dispatch({ type: ACTION_TYPES.UPDATING_V2_SERVICE_ACCOUNT, payload: false });
        return null;
    }
}

export const deleteServiceAccount = (id: string) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { deletingServiceAccount: true } });
    try {
        let res = await api.starlink.delete(`/credentials/${id}`)
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { deletingServiceAccount: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { deletingServiceAccount: false } });
        return null;
    }
}

export const deleteV2ServiceAccount = (parameters: ServiceAccount) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.DELETING_V2_SERVICE_ACCOUNT, payload: true });
    const data = {
        dpId: parameters.dpId,
        accountNumber: parameters.accountNumber
    }
    try {
        let res = await api.starlink.put(`/accounts/delete`, data)
        dispatch({ type: ACTION_TYPES.DELETING_V2_SERVICE_ACCOUNT, payload: false });
        handleResponseObj(res, dispatch, ACTION_TYPES.DELETE_V2_SERVICE_ACCOUNT);
        showNewToastMessage(res)
    } catch (error) {
        dispatch({ type: ACTION_TYPES.DELETING_V2_SERVICE_ACCOUNT, payload:  false });
        return null;
    }
}

export const updateServiceLineDetails = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: true } });
    const data = {
        organizationId: parameters.organizationId,
        accountNumber: parameters.accountNumber,
        serviceLineNumber: parameters.serviceLineNumber,
        nickname: parameters.serviceLineName,
        address: parameters.address,
        emailIds: parameters.emailIds,
        notes: parameters.notes,
        mobileTerminal: parameters?.mobileTerminal
    }
    
    try {
        let res = await api.starlink.put('/service_lines/update_service_line', data, {})
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: false } });
        handleResponseObj(res, dispatch, ACTION_TYPES.UPDATE_SERVICE_LINE_DETAILS)
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: false } });
        return error;
    }
}

export const syncServiceAccounts = (parameters: any) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { syncingServiceAccount: true } });
    try {
        let res = await api.starlink.post('/etl/trigger', parameters, {})
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { syncingServiceAccount: false } });
        handleResponseObj(res, dispatch, ACTION_TYPES.SYNC_SERVICE_ACCOUNTS)
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { syncingServiceAccount: false } });
        return error;
    }
}

export const updatePublicIP = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: true } });
    const data = {
        organizationId: parameters.organizationId,
        accountNumber: parameters.accountNumber,
        serviceLineNumber: parameters.serviceLineNumber,
        publicIP: parameters.publicIP,
    }
    
    try {
        let res = await api.starlink.post('/public_ip/update', data, {})
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: false } });
        handleResponseObj(res, dispatch, ACTION_TYPES.UPDATE_PUBLIC_IP)
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: false } });
        return error;
    }
}

export const getAllSitesWithDevices = (parameters) => (dispatch) => {
    if (_.isEmpty(parameters?.sites)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: true } });
    let _parameters: any = {
        k4Ids: parameters.sites.map(site => `'${site?.id}'`).join(','),
       
    };
    const data = {
        query: `GET_ALL_LOCATIONS`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_ALL_SITES_WITH_DEVICES)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: false } });
        });
}

export const getSitesForTerminal = (parameters) => (dispatch) => {
    if (_.isEmpty(parameters?.terminalId)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: true } });
    let _parameters: any = {
        deviceId: parameters?.terminalId,
       
    };
    const data = {
        query: `GET_SITE_FOR_TERMINAL`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_SITE_FOR_TERMINAL)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: false } });
        });
}

export const getTopUpProductIds = (parameters) => (dispatch) => {
    if (_.isEmpty(parameters?.serviceLineNumber)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: true } });
    let _parameters: any = {
        service_line_number: parameters?.serviceLineNumber,
       
    };
    const data = {
        query: `GET_STARLINK_STANDARD_PLAN_TOP_UPS`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/pg/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_TOP_UP_PRODUCTS)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: false } });
        });
}

export const getStarlinkTerminalRouter = (parameters) => (dispatch) => {
    if (_.isEmpty(parameters?.userTerminalId)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingTerminalRouter: true } });
    let _parameters: any = {
        user_terminal_id: parameters?.userTerminalId,
       
    };
    const data = {
        query: `GET_STARLINK_TERMINAL_ROUTERS`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_ROUTERS_PER_TERMINAL)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingTerminalRouter: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingTerminalRouter: false } });
        });
}

export const getServicelineTerminalRouter = (parameters) => (dispatch) => {
    if (_.isEmpty(parameters?.serviceLineNumber)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServicelineTerminalRouter: true } });
    let _parameters: any = {
        service_line_number: parameters?.serviceLineNumber,
    };
    const data = {
        query: `GET_SERVICE_LINE_TERMINALS_AND_ROUTERS`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_SERVICELINE_TERMINAL_ROUTER)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServicelineTerminalRouter: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServicelineTerminalRouter: false } });
        });
}

export const addSiteToServiceLineApi = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { addingSiteToServiceLine: true } });
    const data = {
        deviceId: parameters.deviceId,
        serviceLineNumber: parameters.serviceLineNumber,
        siteId: parameters.siteId,
        userTerminalId: parameters.userTerminalId
    }
    
    try {
        let res = await api.starlink.post('/service_lines/site_association', data, {})
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { addingSiteToServiceLine: false } });
        handleResponseObj(res, dispatch, ACTION_TYPES.ADD_SITE_TO_SERVICE_LINE)
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { addingSiteToServiceLine: false } });
        return error;
    }
}

export const addTerminalToServiceLine = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { addingUTtoServiceLine: true } });
    const data = {
        organizationId: parameters.organizationId,
        accountNumber: parameters.accountNumber,
        serviceLineNumber: parameters.serviceLineNumber,
        userTerminalId: parameters.userTerminalId
    }
    
    try {
        let res = await api.starlink.post('/user_terminals/create_user_terminal', data, {})
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { addingUTtoServiceLine: false } });
        handleResponseObj(res, dispatch, ACTION_TYPES.ADD_USER_TERMINAL_TO_SERVICE_LINE)
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { addingUTtoServiceLine: false } });
        return error;
    }
}

export const removeTerminalFromServiceLine = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { removeUTfromServiceLine: true } });
    const data = {
        organizationId: parameters.organizationId,
        accountNumber: parameters.accountNumber,
        serviceLineNumber: parameters.serviceLineNumber,
        userTerminalId: parameters.userTerminalId
    }
    
    try {
        let res = await api.starlink.put('/user_terminals/remove_user_terminal', data, {})
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { removeUTfromServiceLine: false } });
        handleResponseObj(res, dispatch, ACTION_TYPES.REMOVE_USER_TERMINAL_FROM_SERVICE_LINE)
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { removeUTfromServiceLine: false } });
        return error;
    }
}

export const rebootTerminal = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { rebootingUserTerminal: true } });
    const data = {
        organizationId: parameters.organizationId,
        accountNumber: parameters.accountNumber,
        userTerminalId: parameters.userTerminalId,
        notes: parameters.notes
    }
    
    try {
        let res = await api.starlink.post('/user_terminals/reboot_user_terminal', data, {})
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { rebootingUserTerminal: false } });
        handleResponseObj(res, dispatch, ACTION_TYPES.REBOOT_USER_TERMINAL)
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { rebootingUserTerminal: false } });
        return error;
    }
}

export interface TopUpParams {
    organizationId: string[];
    accountNumber: string;
    unit: string;
    topup: number;
    credentialId: string;
    serviceLineNumber:string;
    parentPoolId:string;
    childPoolId:string;
    customPlanId:string;
}

export const topUpParentPool = (parameters: TopUpParams) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_TOPUP_LOADING, payload: { addingTopup: true } });
    const data = {
        organizationId: parameters?.organizationId,
        accountNumber: parameters?.accountNumber,
        topup: parameters?.topup,
        unit: parameters?.unit
    }
    
    try {
        let res = await api.starlink.post(`/parentPools/${parameters?.parentPoolId}/topup`, data, {})
        dispatch({ type: ACTION_TYPES.SET_TOPUP_LOADING, payload: { addingTopup: false } });
        handleResponseObj(res, dispatch, ACTION_TYPES.ADD_TOPUP_TO_PARENT_POOL)
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_TOPUP_LOADING, payload: { addingTopup: false } });
        return error;
    }
}

export const topUpChildPool = (parameters: TopUpParams) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_TOPUP_LOADING, payload: { addingTopup: true } });
    const data = {
        organizationId: parameters?.organizationId,
        accountNumber: parameters?.accountNumber,
        topup: parameters?.topup,
        unit: parameters?.unit
    }
    
    try {
        let res = await api.starlink.post(`/parentPools/${parameters?.parentPoolId}/childPools/${parameters?.childPoolId}/topup`, data, {})
        dispatch({ type: ACTION_TYPES.SET_TOPUP_LOADING, payload: { addingTopup: false } });
        handleResponseObj(res, dispatch, ACTION_TYPES.ADD_TOPUP_TO_CHILD_POOL)
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_TOPUP_LOADING, payload: { addingTopup: false } });
        return error;
    }
}

export const topUpServiceLine = (parameters: TopUpParams) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_TOPUP_LOADING, payload: { addingTopup: true } });
    const data = {
        credentialId: parameters?.credentialId,
        organizationId: parameters?.organizationId,
        accountNumber: parameters?.accountNumber,
        serviceLineNumber: parameters?.serviceLineNumber,
        topup: parameters.topup,
        unit: parameters?.unit,
        customPlanId:parameters?.customPlanId
    }
    
    try {
        let res = await api.starlink.post('/service_lines/add_topup', data, {})
        dispatch({ type: ACTION_TYPES.SET_TOPUP_LOADING, payload: { addingTopup: false } });
        handleResponseObj(res, dispatch, ACTION_TYPES.ADD_TOPUP_TO_SERVICE_LINE)
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_TOPUP_LOADING, payload: { addingTopup: false } });
        return error;
    }
}


export const topUpStandardServiceLine = (parameters) => async (dispatch) => {
    if(_.isEmpty(parameters?.serviceLineNumber) || _.isEmpty(parameters?.organizationId) || _.isEmpty(parameters?.accountNumber) || _.isEmpty(parameters?.productReferenceId) || _.isEmpty(parameters?.topupBlockProducts) ) {
        return
    }

    dispatch({ type: ACTION_TYPES.SET_TOPUP_LOADING, payload: { addingTopup: true } });
    const data = {
        organizationId: parameters?.organizationId,
        accountNumber: parameters?.accountNumber,
        credentialId: parameters?.credentialId,
        serviceLineNumber: parameters?.serviceLineNumber,
        productReferenceId: parameters?.productReferenceId,
        topupBlockProducts: parameters?.topupBlockProducts
    }
    
    try {
        let res = await api.starlink.post('/service_lines/add_standard_plan_topup', data, {})
        dispatch({ type: ACTION_TYPES.SET_TOPUP_LOADING, payload: { addingTopup: false } });
        handleResponseObj(res, dispatch, ACTION_TYPES.ADD_TOPUP_TO_STANDARD_SERVICE_LINE)
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_TOPUP_LOADING, payload: { addingTopup: false } });
        return error;
    }
}
export interface getServiceLinesParameters {
    dpIds: string[];
    searchText: string;
    sortBy: string;
    sortOrder: string;
    page: number;
    limit: number;
    serviceLineStatus:('true' | 'false')[];
    serviceLines: string[];
    accounts:any;
    kitFilter: string;
    subFilter: string;
    activeFilter: string,
}

let latestRequestId = 0;
export const getServiceLines = (parameters: getServiceLinesParameters) => (dispatch) => {
    // if (_.isEmpty(parameters?.dpIds)) return;
    if (parameters?.serviceLines?.includes('All') ) return;
    const requestId = ++latestRequestId;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: true } });
    let _parameters: any = {
        // dpIds: parameters.dpIds.map(dpId => `'${dpId}'`).join(','),
        accounts: parameters?.accounts?.map(dpId => `'${dpId}'`).join(','),
        searchText: parameters?.searchText,
        sortBy: parameters?.sortBy,
        sortOrder: parameters?.sortOrder,
        limit: parameters?.limit,
        offset: (parameters?.page - 1) * parameters?.limit,
        kitFilter: parameters?.kitFilter ?  parameters?.kitFilter : "",
        subFilter: parameters?.subFilter ? parameters?.subFilter : "",
        activeFilter: parameters?.activeFilter ?  parameters?.activeFilter : "",
        // serviceLineStatus:  parameters?.serviceLineStatus?.map(status => `'${status}'`).join(','),
        serviceLines:  parameters?.serviceLines?.map(serviceLine => `'${serviceLine}'`).join(',')
    };
    const data = {
         query: `GET_SERVICE_LINES_ADMIN_WITH_FILTERS`,
        named: true,
        format: 'csv',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/pg/query`, data)
        .then((res) => {
            if (requestId !== latestRequestId) return;
            handleResponse(res, dispatch, ACTION_TYPES.GET_SERVICE_LINES)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: false } });
        })
        .catch((err) => {
            if (requestId !== latestRequestId) return;
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: false } });
        });
}

export const getServiceLinesForSubcription = (parameters: getServiceLinesParameters) => (dispatch) => {
    if (_.isEmpty(parameters?.serviceLines)) return;
    if (parameters?.serviceLines?.includes('All') ) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: true } });
    let _parameters: any = {
        accounts: parameters?.accounts?.map(dpId => `'${dpId}'`).join(','),
        searchText: parameters?.searchText,
        sortBy: parameters?.sortBy,
        sortOrder: parameters?.sortOrder,
        limit: parameters?.limit,
        offset: (parameters?.page - 1) * parameters?.limit,
        kitFilter: "where kitCount = 0 or kitCount > 0",
        subFilter: "",
        activeFilter: "",
        // serviceLineStatus:  parameters?.serviceLineStatus?.map(status => `'${status}'`).join(','),
        serviceLines:  parameters?.serviceLines?.map(serviceLine => `'${serviceLine}'`).join(',')
    };
    const data = {
        query: `GET_SERVICE_LINES_ADMIN_WITH_FILTERS`,
        named: true,
        format: 'csv',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/pg/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_SERVICE_LINES_FOR_SUBSCRIPTION)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: false } });
        });
}


export const getOrganizationList = (parameters) => (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: true } });
    let _parameters: any = {
        dpId:parameters?.dpId,
        searchText:parameters?.searchText,
        sortBy:parameters?.sortBy,
        sortOrder:parameters?.sortOrder,
        limit:parameters?.limit,
        offset:parameters?.offset,
    };
    const data = {
        query:`GET_STARLINK_SUB_ORGANIZATIONS`,
        named: true,
        format: 'csv',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/pg/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_ORGANIZATION_LIST)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: false } });
        });
}

export const getCustomPlansList = (parameters) => (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: true } });
    let _parameters: any = {
        dpId:parameters?.dpIds?.map(dpId => `'${dpId}'`).join(','),
        searchText:parameters?.searchText,
        sortBy:parameters?.sortBy,
        sortOrder:parameters?.sortOrder,
        limit:parameters?.limit,
        offset:parameters?.offset,
    };
    const data = {
        query:`GET_STARLINK_CUSTOM_PLANS`,
        named: true,
        format: 'csv',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/pg/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_CUSTOM_PLANS)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: false } });
        });
}

export const getParentPoolList = (parameters) => (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: true } });
    let _parameters: any = {
        dpIds:parameters?.dpIds?.map(dpId => `'${dpId}'`).join(','),
        searchText:parameters?.searchText,
        sortBy:parameters?.sortBy,
        sortOrder:parameters?.sortOrder,
        limit:parameters?.limit,
        offset:parameters?.offset,
        childPools:parameters?.childPools
    };
    const data = {
        query:`GET_STARLINK_PARENT_POOL_LIST`,
        named: true,
        format: 'csv',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/pg/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_STARLINK_PARENT_POOL_LIST)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: false } });
        });
}

export const createCustomPlan = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: true } });
    const data = {
        credentialId: parameters?.credentialId,
            parentPoolId: parameters?.parentPoolId,
            accountNumber: parameters?.accountNumber,
            childPoolId: parameters?.childPoolId,
            createdBy: parameters?.createdBy,
            planName: parameters?.planName,
            planSize: parameters?.planSize,
            isRecurring: parameters?.isRecurring,
            planInfo: parameters?.planInfo,
            organizationIds: parameters?.dpIds,
            duration: parameters?.duration,
            planUsage: parameters?.planUsage,
            billingDate: parameters?.billingDate,
            unit: parameters?.unit,
            usersToNotify: parameters?.usersToNotify,
            quotaActions: parameters?.entries,
            planType: parameters?.planType,
            notificationMethods: parameters?.notificationMethods
    }
    
    try {
        let res = await api.starlink.post('/customPlans', data, {})
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: false } });
        return error;
    }
}

export const updateCustomPlan = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: true } });
    const data = {
        customPlanId: parameters.customPlanId,
        credentialId: parameters?.credentialId,
            parentPoolId: parameters?.parentPoolId,
            accountNumber: parameters?.accountNumber,
            childPoolId: parameters?.childPoolId,
            createdBy: parameters?.createdBy,
            planName: parameters?.planName,
            planSize: parameters?.planSize,
            isRecurring: parameters?.isRecurring,
            planInfo: parameters?.planInfo,
            organizationIds: parameters?.dpIds,
            duration: parameters?.duration,
            planUsage: parameters?.planUsage,
            billingDate: parameters?.billingDate,
            unit: parameters?.unit,
            usersToNotify: parameters?.usersToNotify,
            quotaActions: parameters?.entries,
            notificationMethods: parameters?.notificationMethods
    }
    
    try {
        let res = await api.starlink.put(`/customPlans/${parameters?.customPlanId}`, data, {})
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: false } });
        return error;
    }
}

export const assignCustomPlan = (parameters) => async (dispatch) => {
    if(!parameters?.organizationId) return
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: true } });
    const data = {
        serviceLineNumber: parameters.serviceLineNumber,
        accountNumber: parameters?.accountNumber || "",
        kitIds: parameters?.userTerminalId || "",
        productReferenceId: parameters?.productReferenceId || "",
        customPlanId: parameters?.customPlanId || "",
        organizationId : parameters?.organizationId,
        // allowDowngradeNow: parameters?.allowDowngradeNow,  
        scheduled: parameters?.allowDowngradeNow,  
        dataBlockProducts: parameters?.dataBlockProducts ? parameters?.dataBlockProducts : null,
        action: parameters?.action ? parameters?.action : 'optIn',
        pauseServiceLine: parameters?.pauseServiceLine ? parameters?.pauseServiceLine : false
    }
    
    try {
        let res = await api.starlink.put(`/service_lines/assign_service_plan`, data, {})
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: false } });
        handleResponseObj(res, dispatch, ACTION_TYPES.ASSIGN_CUSTOM_PLAN)
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: false } });
        return error;
    }
}

export const createServiceLine = (parameters) => async (dispatch) => {
    if(!parameters?.organizationId) return
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: true } });
    const data = {
        name: parameters?.name,
            customPlanId:parameters?.customPlanId,
            productReferenceId:parameters?.productReferenceId,
            accountNumber:parameters?.accountNumber,
            address:parameters?.address,
            organizationId:parameters?.organizationId,
            userTerminalIds:parameters?.userTerminalId,
            emailIds:parameters?.emailIds,
            dataBlockProducts: parameters?.dataBlockProducts,
            type: parameters?.type,
            notes: parameters?.notes,
            mobileTerminal: parameters?.mobileTerminal
    }

    try {
        let res = await api.starlink.post('/service_lines/new_service_line_v2', data, {})
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: false } });
        return error;
    }
}

export const geocodeServiceAddress = (parameters) => async (dispatch) => {
    try {
        let res = await api.starlink.post('/service_lines/geocode_address', { address: parameters?.address }, {})
        return res;
    } catch (error: any) {
        return { success: false, message: error?.response?.data?.message || error?.message || "Failed to geocode address" };
    }
}

export const getAvailableProductsForAccount = (parameters) => (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: true } });
    let _parameters: any = {
       accountNumber:parameters?.accountNumber
    };
    const data = {
        query: `GET_AVAILABLE_PRODUCTS_FOR_ACCOUNT`,
        named: true,
        format: 'csv',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/pg/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_AVAILABLE_PRODUCTS_FOR_ACCOUNT)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: false } });
        });
}

export interface parametersUpdateServiceLineOrganization {
    serviceLineNumber: string;
    dpId: string;
}

export const updateServiceLineOrganization = (parameters: parametersUpdateServiceLineOrganization) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingServiceLine: true } });
    const data = {
        dpId: parameters.dpId,
    }
    try {
        let res = await api.starlink.put(`/service-lines/${parameters.serviceLineNumber}/organization`, data)
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingServiceLine: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingServiceLine: false } });
        return null;
    }
}

export interface parametersBulkUpdateServiceLineOrganization {
    serviceLineNumbers: string[];
    dpId: string;
}

export const bulkUpdateServiceLineOrganization = (parameters: parametersBulkUpdateServiceLineOrganization) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingServiceLine: true } });
    try {
        let res = await api.starlink.put(`/service-lines/organization`, parameters)
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingServiceLine: false } });
        showToastMessage(res, 'Change Sub Org');
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingServiceLine: false } });
        return null;
    }
}

export const updateMultipleServiceLineOrganization = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingServiceLine: true } });
    try {
        let res = await api.starlink.put(`/service-lines/updateOrganization`, parameters)
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingServiceLine: false } });
        showToastMessage(res, 'Change Sub Org');
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingServiceLine: false } });
        return null;
    }
}

export const addKitToWarehouseAPI = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { addingKitToWareHouse: true } });
    try {
        let res = await api.starlink.post(`/user_terminals/add_terminal_to_warehouse`, parameters, {})
        handleResponseObj(res, dispatch, ACTION_TYPES.ADD_KIT_TO_WAREHOUSE)
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { addingKitToWareHouse: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { addingKitToWareHouse: false } });
        return null;
    }
}

export interface getUserTerminalsParameters {
    dpIds: string[];
    searchText: string;
    sortBy: string;
    sortOrder: string;
    page: number;
    limit: number;
    terminalStatus: ('deployed' | 'in-warehouse')[];
    serviceLines: string[];
    accounts:any
}

export const getUserTerminals = (parameters: getUserTerminalsParameters) => (dispatch) => {
   if (_.isEmpty(parameters?.dpIds)) return;
    if (parameters?.serviceLines?.includes('All') ) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: true } });
   let _parameters: any = {
       dpIds: parameters.dpIds.map(dpId => `'${dpId}'`).join(','),
        accountNumbers: parameters?.accounts?.length ? parameters?.accounts?.map(acc => `'${acc}'`).join(',') : "''",
        serviceLines:  parameters?.serviceLines?.length ? parameters?.serviceLines?.map(sl => `'${sl}'`).join(',')  : "''",
        searchText: parameters.searchText,
        sortBy: parameters.sortBy,
        sortOrder: parameters.sortOrder,
        limit: parameters.limit,
        offset: (parameters.page - 1) * parameters.limit,
        terminalStatus: parameters.terminalStatus.map(status => `'${status}'`).join(','),
    };
    const data = {
        query: `OPT_GET_USER_TERMINALS_ADMIN`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_USER_TERMINALS)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: false } });
        });
}

export const getSubscriptionForAccount = (parameters) => (dispatch) => {
    if (_.isEmpty(parameters?.dpIds)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: true } });
    let _parameters: any = {
        dpId: parameters.dpIds,
    };
    const data = {
        query: `GET_STARLINK_PLANS_ADDRESSES_AND_TERMINALS`,
        named: true,
        format: 'csv',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/pg/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_SUBSCRIPTION_FOR_ACCOUNT)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: false } });
        });
}

export interface extractThroughCredentialParameters {
    id?: string;
    username?: string;
    clientId?: string;
    skipUsage?: boolean;
}

export const extractThroughCredential = (parameters: extractThroughCredentialParameters, abortSignal: AbortSignal | undefined) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingServiceAccount: true } });
    const data = {}
    for (let param of Object.keys(parameters)) {
        if (parameters[param]) {
            data[param] = parameters[param];
        }
    }
    try {
        let res = await api.starlink.post(`/credentials/extract`, data, {}, abortSignal)
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingServiceAccount: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingServiceAccount: false } });
        return null;
    }
}

export interface getServiceLineByCredentialParameters extends extractThroughCredentialParameters {}

export const getAllServiceLinesByCredential = (parameters: getServiceLineByCredentialParameters, abortSignal: AbortSignal | undefined) => async (dispatch) => {
    if (_.isEmpty(parameters?.clientId) && _.isEmpty(parameters?.username)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: true } });
    let _parameters = {
        clientId: parameters.clientId,
        username: parameters.username,
    };
    const data = {
        query: `GET_SERVICE_LINES_WORKFLOW`,
        named: true,
        format: 'csv',
        parameters: _parameters
    }
    try {
        let res = await api.postRequestOut(`/store/ch/query`, data, abortSignal)
        handleResponse(res, dispatch, ACTION_TYPES.GET_ALL_SERVICE_LINES_BY_CREDENTIAL)
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: false } });
    } catch (err) {
        handleError(err, dispatch);
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: false } });
    }
}

export const getCustomPlanPerDP = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: true } });
    let _parameters = {
        subOrgId: parameters.subOrgId,
    };
    const data = {
        query: `GET_CUSTOM_PLAN_LIST`,
        named: true,
        format: 'csv',
        parameters: _parameters
    }
    try {
        let res = await api.postRequestOut(`/store/pg/query`, data)
        handleResponse(res, dispatch, ACTION_TYPES.GET_CUSTOM_PLAN_PER_DP)
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: false } });
    } catch (err) {
        handleError(err, dispatch);
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: false } });
    }
}


export interface createSubOrgParameters {
    DPName: string;
    DPFullName: string;
    parentName: string;
}

export const createSubOrg = (parameters: createSubOrgParameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: true } });    
    try {
        let res = await api.postRequestForExternalApi(`${KAPTUREV2_URL_INV}vessels/addDP`, parameters)
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: false } });
        return res.data;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingServiceAccount: false } });
        return error;
    }
}

export const clearComponentData = () => (dispatch) => {
    dispatch({ type: ACTION_TYPES.GET_SERVICE_ACCOUNTS, payload: { data: { rows: [[[], 0]] } } })
    dispatch({ type: ACTION_TYPES.GET_V2_SERVICE_ACCOUNTS, payload: { data: { rows: [[[], 0]] } } })
    dispatch({ type: ACTION_TYPES.GET_STARLINK_AUDIT_LOGS,  payload: { data: [{result:[]}]} })
    dispatch({ type: ACTION_TYPES.GET_USER_TERMINALS,  payload: { data: { rows: [[[], 0]] } } })
    dispatch({ type: ACTION_TYPES.GET_SUBSCRIPTION_FOR_ACCOUNT,  payload: { data: { rows: [[[], 0]] } } })
    dispatch({ type: ACTION_TYPES.GET_SERVICE_LINES,  payload: { data: { rows: [[[], 0]] } } })
    // dispatch({
}

export const subscribeToServiceLines = (parameters) => async (dispatch) => {
    if (_.isEmpty(parameters?.serviceLineNumber)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { subcribingServiceLine: true } });
    try {
        let res = await api.starlink.post('/service_lines/subscriptions', parameters)
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { subcribingServiceLine: false } });
        handleResponseObj(res, dispatch, ACTION_TYPES.SUBSCRIBE_SERVICE_LINES)
        showToastMessage(res, 'Subscribe');
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { subcribingServiceLine: false } });
        return null;
    }
}

export const getServiceLineSubscription = (parameters) => async (dispatch) => {
    if (_.isEmpty(parameters?.dpId)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { subcribingServiceLine: true } });
    try {
        let res = await api.starlink.post('/service_lines/getSubscriptionData', parameters)
       
            handleResponse(res, dispatch, ACTION_TYPES.GET_SERVICE_LINES_SUBSCRIPTIONS)
        
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { subcribingServiceLine: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { subcribingServiceLine: false } });
        return null;
    }
}

const showToastMessage = (res, handler) => {
   if(res.success == false) {
    toast.error(`${handler} : ${res.message}, Please Try Later.`, {
        position: toast.POSITION.BOTTOM_LEFT,
      })
   } else {
    toast.success(res.message, {
        position: toast.POSITION.BOTTOM_LEFT,
      })
   }
}

const showNewToastMessage = (res,) => {
   if(res.success == false) {
    toast.error(`${res.message}`, {
        position: toast.POSITION.BOTTOM_LEFT,
      })
   } else {
    toast.success(res.message, {
        position: toast.POSITION.BOTTOM_LEFT,
      })
   }
}

export const optInForServiceLine = (parameters) => async (dispatch) => {
    if (_.isEmpty(parameters?.serviceLineNumber)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { subcribingServiceLine: true } });
    try {
        let res = await api.starlink.post('/service_lines/optInOptOut', parameters)

        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { subcribingServiceLine: false } });
        dispatch({ type: ACTION_TYPES.GET_OPTIN_SERVICE_LINE, payload: res });
        showToastMessage(res, 'Mobile Priority');
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { subcribingServiceLine: false } });
        return null;
    }
}

export const pauseResumeServiceLine = (parameters) => async (dispatch) => {
    if (_.isEmpty(parameters?.serviceLineNumber)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { subcribingServiceLine: true } });
    try {
        let res = await api.starlink.post('/service_lines/pauseResume', parameters)

        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { subcribingServiceLine: false } });
        showToastMessage(res, 'Pause/Resume SL');
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { subcribingServiceLine: false } });
        return null;
    }
}

export const updateNonAdminPermissions = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingNonAdminPermissions: true } });
    try {
        api.putRequest(`/iam/starlink/dps/permissions`, parameters?.data)
                .then((res) => handleResponse(res, dispatch, ACTION_TYPES.UPDATE_NON_ADMIN_PERMISSIONS))
                .catch((err) => handleError(err, dispatch));

    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingNonAdminPermissions: false } });
        return null;
    }
}

export const getNonAdminPermissions = (parameters) => async (dispatch) => {
    
    if (_.isEmpty(parameters?.dpId)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingNonAdminPermissions: true } });
    try {
        let res = await getRequest(`/iam/starlink/dpId/${parameters?.dpId}/permissions?parentDpId=${parameters?.parentDpId}`)
            handleResponse(res, dispatch, ACTION_TYPES.GET_NON_ADMIN_PERMISSIONS)
        
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingNonAdminPermissions: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingNonAdminPermissions: false } });
        return null;
    }
}

export const getParentDP = (parameters) => async (dispatch) => {
    
    if (_.isEmpty(parameters?.dp)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingNonAdminPermissions: true } });
    try {
        let res = await getRequest(`/iam/ou/details?name=${parameters?.dp}`)
            handleResponse(res, dispatch, ACTION_TYPES.GET_PARENT_DP)
        
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingNonAdminPermissions: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingNonAdminPermissions: false } });
        return null;
    }
}


export const getStarlinkAuditLogs = (parameters) => (dispatch) => {
    clearComponentData()
    if (_.isEmpty(parameters?.dpIds)) return;
    if (_.isEmpty(parameters?.serviceLines)) return;
    if (parameters?.serviceLines?.includes('All') ) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: true } });
    let _parameters: any = {
        dpIds: parameters?.dpIds?.map(dpId => `'${dpId}'`).join(','),
        searchText: parameters.searchText,
        sortBy: parameters.sortBy,
        sortOrder: parameters.sortOrder,
        limit: parameters.limit,
        offset: (parameters.page - 1) * parameters.limit,
        page: parameters.page,
        serviceLines: parameters.serviceLines.map(serviceLine => `'${serviceLine}'`).join(',')
    };
    const data = {
        query: `GET_STARLINK_AUDIT_LOGS`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/pg/query`, data, parameters?.signal)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_STARLINK_AUDIT_LOGS)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: false } });
        });
}

export const cancelScheduledPlan = (parameters) => async(dispatch) => {
    if(!parameters?.serviceLineNumber) return
    dispatch({type: ACTION_TYPES.SET_LOADING, payload: {cancelScheduledPlan: true}})
    
    return api.starlink.put(`/service_lines/cancelScheduledPlan/${parameters?.serviceLineNumber}`, parameters, {})
        .then((res) => {
            dispatch({type: ACTION_TYPES.SET_LOADING, payload: {cancelScheduledPlan: false}})
            dispatch({type: ACTION_TYPES.CANCEL_SCHEDULED_PLAN, payload: res})
            showToastMessage(res, 'Scheduled Plans Cancelled Successfully.')
            return
        })
        .catch((err) => {
            dispatch({type: ACTION_TYPES.SET_LOADING, payload: {cancelScheduledPlan: false}})
            return err
        })
}

export const updateRouterConfig = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingRouterConfig: true } });
    const data = {
        organizationId: parameters?.organizationId,
        accountNumber: parameters?.accountNumber,
        userTerminalId: parameters?.userTerminalId,
        networks: parameters?.networks,
        applyBypassMode: parameters?.applyBypassMode,
        configId: parameters?.configId
    }

    return api.starlink.put(`/update_router_config`, data, {})
        .then((res) => {
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingRouterConfig: false } })
            dispatch({type: ACTION_TYPES.APPLY_ROUTER_CONFIG, payload: res})
            showToastMessage(res, 'Router Config is applied. It will reflect in few minutes.')
            return
        })
        .catch((err) => {
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingRouterConfig: false } })
            return err
        })
}

export const removeTerminalAPI = (parameters) => async (dispatch) => {
    if(!parameters?.userTerminalId ) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { removingUserTerminal: true } });
    const data = {
        organizationId: parameters.organizationId,
        accountNumber: parameters.accountNumber,
        userTerminalId: parameters.userTerminalId
    }
    
    try {
        let res = await api.starlink.delete('/user_terminals/remove_terminal', data, {})
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { removingUserTerminal: false } });
        handleResponseObj(res, dispatch, ACTION_TYPES.REMOVE_USER_TERMINAL)
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { removingUserTerminal: false } });
        return error;
    }
}
export const getRouterConfig = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingRouterConfig: true } });

    return api.starlink.get(`/get_router_configs/organizationId/${parameters?.organizationId}/accountNumber/${parameters?.accountNumber}?configId=${parameters?.configId}`)
        .then((res) => {
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingRouterConfig: false } })
            dispatch({type: ACTION_TYPES.GET_ROUTER_CONFIG, payload: res})
            // showToastMessage(res, 'Router Config is applied. It will reflect in few minutes.')
            return
        })
        .catch((err) => {
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingRouterConfig: false } })
            return err
        })
}

export const getRouterConfigs = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingRouterConfigs: true } });

    return api.starlink.get(`/get_router_configs/organizationId/${parameters?.organizationId}/accountNumber/${parameters?.accountNumber}`)
        .then((res) => {
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingRouterConfigs: false } })
            dispatch({type: ACTION_TYPES.GET_ROUTER_CONFIGS, payload: res})
            // showToastMessage(res, 'Router Config is applied. It will reflect in few minutes.')
            return
        })
        .catch((err) => {
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingRouterConfigs: false } })
            return err
        })
}

export const getRebootRouter = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { rebootingRouter: true } });
    const data = {
        organizationId: parameters.organizationId,
        accountNumber: parameters.accountNumber,
        routerId: parameters.routerId
    }
    
    try {
        let res = await api.starlink.post('/reboot_router', data, {})
        handleResponseObj(res, dispatch, ACTION_TYPES.REBOOT_ROUTER)
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { rebootingRouter: false } });
        showToastMessage(res, 'Router is rebooted Successfully')
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { rebootingRouter: false } });
        return error;
    }
}

export const assignRouterConfig = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { assigningRouterConfig: true } });
    const data = {
        organizationId: parameters?.organizationId,
        accountNumber: parameters?.accountNumber,
        routerId: parameters?.routerId?.replace(/^Router-/, ''),
        configId: parameters?.configId
    }

    return api.starlink.put(`/set_router_config`, data, {})
        .then((res) => {
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { assigningRouterConfig: false } })
            dispatch({type: ACTION_TYPES.ASSIGN_ROUTER_CONFIG, payload: res})
            showToastMessage(res, 'Router Config is assigned. It will reflect in few minutes.')
            return
        })
        .catch((err) => {
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { assigningRouterConfig: false } })
            return err
        })
}

export const validateRouterConfig = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { validatingRouterConfig: true } });
    const data = {
        organizationId: parameters.organizationId,
        accountNumber: parameters.accountNumber,
        configName: parameters.configName,
        configId: parameters.configId,
        configJson: parameters.configJson,
    }
    
    return api.starlink.put(`/v2/validate_router_config`, data, {})
        .then((res) => {
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { validatingRouterConfig: false } })
            dispatch({type: ACTION_TYPES.VALIDATE_ROUTER_CONFIG, payload: res})
            showToastMessage(res, 'Router Config is Validated. It will reflect in few minutes.')
            return
        })
        .catch((err) => {
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { validatingRouterConfig: false } })
            return err
        })
}

export const updateRouterConfiguration = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingRouterConfiguration: true } });
    const data = {
        organizationId: parameters.organizationId,
        accountNumber: parameters.accountNumber,
        configName: parameters.configName,
        configId: parameters.configId,
        configJson: parameters.configJson,
    }

    return api.starlink.put(`/v2/update_router_config`, data, {})
        .then((res) => {
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingRouterConfiguration: false } })
            dispatch({type: ACTION_TYPES.UPDATE_ROUTER_CONFIGURATION, payload: res})
            showToastMessage(res, 'Router Config is Updated. It will reflect in few minutes.')
            return
        })
        .catch((err) => {
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingRouterConfiguration: false } })
            return err
        })
}

export const createRouterConfig = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingRouterConfig: true } });
    const data = {
        organizationId: parameters.organizationId,
        accountNumber: parameters.accountNumber,
        configName: parameters.configName,
        configJson: parameters.configJson
    }
    
    try {
        let res = await api.starlink.post(`/create_router_config`, data, {})
        handleResponseObj(res, dispatch, ACTION_TYPES.CREATE_ROUTER_CONFIG)
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingRouterConfig: false } });
        showToastMessage(res, 'Router Config Created Successfully')
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingRouterConfig: false } });
        return error;
    }
}

export const getUserTerminalsForAssign = (parameters: getUserTerminalsParameters) => (dispatch) => {
   if (_.isEmpty(parameters?.dpIds)) return;
    if (parameters?.serviceLines?.includes('All') ) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: true } });
   let _parameters: any = {
       dpIds: parameters.dpIds.map(dpId => `'${dpId}'`).join(','),
        accountNumbers: parameters?.accounts?.length ? parameters?.accounts?.map(acc => `'${acc}'`).join(',') : "''",
        serviceLines:  parameters?.serviceLines?.length ? parameters?.serviceLines?.map(sl => `'${sl}'`).join(',')  : "''",
        searchText: parameters.searchText,
        sortBy: parameters.sortBy,
        sortOrder: parameters.sortOrder,
        limit: parameters.limit,
        offset: (parameters.page - 1) * parameters.limit,
        terminalStatus: parameters.terminalStatus.map(status => `'${status}'`).join(','),
    };
    const data = {
        query: `OPT_GET_USER_TERMINALS_ADMIN`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_USER_TERMINALS_FOR_ASSIGN)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: false } });
        });
}

export const moveUserTerminals = (parameters) => async (dispatch) => {
      if (_.isEmpty(parameters?.organizationId) || parameters?.userTerminalIds?.length === 0) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { moveUserTerminalsLoading: true } });

    try {
        let res = await api.starlink.put('/user_terminals/transfer_organization', parameters, {})
         handleResponseObj(res, dispatch, ACTION_TYPES.ASSIGN_USER_TERMINAL_TO_SUBORG)
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { moveUserTerminalsLoading: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { moveUserTerminalsLoading: false } });
        return error;
    }
}

export const getDPOAccount = (parameters) => async (dispatch) => {
    if (_.isEmpty(parameters?.dpId)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingDPOAccount: true } });
    try {
        let res = await api.starlink.get(`/accounts/dpo/getAccount/${parameters?.dpId}`)
        handleResponse(res, dispatch, ACTION_TYPES.GET_DPO_ACCOUNT)

        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingDPOAccount: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingDPOAccount: false } });
        // return null;
    }
}

export const createDPOAccount = (parameters) => async (dispatch) => {
    if (_.isEmpty(parameters?.dpId)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingDPOAccount: true } });
    try {
        let res = await api.starlink.post('/accounts/dpo/createAccount', parameters, {})
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingDPOAccount: false } });
        showToastMessage(res, 'Account Created Successfully')
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingDPOAccount: false } });
        return error;
    }
}

export const updateDPOAccount = (parameters) => async (dispatch) => {
       if (_.isEmpty(parameters?.dpId)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingDPOAccount: true } });
    try {
        let res = await api.starlink.post('/accounts/dpo/updateAccount', parameters, {})
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingDPOAccount: false } });
        showToastMessage(res, 'Account Updated Successfully')
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingDPOAccount: false } });
        return error;
    }
}

export const getDPOProduct = (parameters) => async (dispatch) => {
    if (_.isEmpty(parameters?.dpId)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingDPOAccount: true } });
    try {
        let res = await api.starlink.get(`/accounts/dpo/getProduct/${parameters?.dpId}`)
        handleResponse(res, dispatch, ACTION_TYPES.GET_DPO_PRODUCTS)
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingDPOAccount: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingDPOAccount: false } });
    }
}

export const deleteDPOAccount = (parameters) => async (dispatch) => {
    if (_.isEmpty(parameters?.dpId)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingDPOAccount: true } });
    try {
        let res = await api.starlink.delete(`/accounts/dpo/deleteAccount/${parameters?.dpId}`)
        handleResponse(res, dispatch, ACTION_TYPES.DELETE_DPO_Account)

        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingDPOAccount: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingDPOAccount: false } });
    }
}

export const initiateDpoPayment = (parameters) => async (dispatch) => {
     if (_.isEmpty(parameters?.dpId)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingDPOAccount: true } });

    let params = {
        dpId: parameters?.dpId,
        companyToken: parameters?.companyToken,
        serviceLineNumber: parameters?.serviceLineNumber,
        accountNumber: parameters?.accountNumber,
        notes: parameters?.notes,
        redirectURL: parameters?.redirectURL,
        backURL: parameters?.backURL,
        dataAmount: parameters?.dataAmount,
        dataUnit: parameters?.dataUnit,
        count: parameters?.count
    }

    try {
        let res = await api.starlink.post('/payments/dpo/initiate', params, {})
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingDPOAccount: false } });
        handleResponseObj(res, dispatch, ACTION_TYPES.INITIATE_DPO_PAYMENT)
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingDPOAccount: false } });
        return error;
    }
}

export const getDpoPaymentStatus = (parameters) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingDPOAccount: true } });
    dispatch({ type: ACTION_TYPES.GET_DPO_PAYMENT_STATUS, payload: { } });
    try {
        let res = await api.starlink.get(`/payments/dpo/status/${parameters?.transactionId}`)
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingDPOAccount: false } });
        handleResponseObj(res, dispatch, ACTION_TYPES.GET_DPO_PAYMENT_STATUS)
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingDPOAccount: false } });
        return error;
    }
}

export const getValidDPOs = (parameters) => (dispatch) => {
   if (_.isEmpty(parameters?.dpId)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: true } });

    const data = {
        query: `GET_STARLINK_VALID_DPO_DPS`,
        named: true,
        format: 'json',
        parameters: parameters
    }
    api
        .postRequestOut(`/store/pg/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_STARLINK_VALID_DPO_DPS)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingUserTerminals: false } });
        });
}

export const getDPOAccountAccountInfo = (parameters) => (dispatch) => {
   if (_.isEmpty(parameters?.dpId)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingDPOAccount: true } });

    const data = {
        query: `GET_STARLINK_ORGANIZATION_DPO_ACCOUNT`,
        named: true,
        format: 'json',
        parameters: parameters
    }
    api
        .postRequestOut(`/store/pg/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_DPO_ACCOUNT_INFO)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingDPOAccount: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingDPOAccount: false } });
        });
}

export const verifyDPOAccount = (parameters) => async (dispatch) => {
       if (_.isEmpty(parameters?.dpId)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingDPOAccount: true } });
    try {
        let res = await api.starlink.post('/accounts/dpo/verifyAccount', parameters, {})
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingDPOAccount: false } });
         handleResponseObj(res, dispatch, ACTION_TYPES.GET_VERIFY_DPO_ACCOUNT)
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingDPOAccount: false } });
        handleResponseObj(error, dispatch, ACTION_TYPES.GET_VERIFY_DPO_ACCOUNT)
    }
}

export const cancelDPOTransaction = (parameters) => async (dispatch) => {
       if (_.isEmpty(parameters?.dpId)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingDPOAccount: true } });
    try {
        let res = await api.starlink.post('/payments/dpo/cancel', parameters, {})
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingDPOAccount: false } });
         handleResponseObj(res, dispatch, ACTION_TYPES.CANCEL_DPO_TRANSACTION)
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingDPOAccount: false } });
        return error;
    }
}

export const getRouterConfigVisibility = (parameters: { dpId: string }) => async (dispatch) => {
    if (!parameters?.dpId) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingRouterConfigVisibility: true } });
    try {
        let res = await api.starlink.get(`/router-config/visibility?dpId=${parameters.dpId}`, {})
        handleResponseObj(res, dispatch, ACTION_TYPES.GET_ROUTER_CONFIG_VISIBILITY)
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingRouterConfigVisibility: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.GET_ROUTER_CONFIG_VISIBILITY, payload: { data: { visibility: 'enabled' } } });
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingRouterConfigVisibility: false } });
        return error;
    }
}

export const setRouterConfigVisibility = (parameters: { dpIds: any; visibility: string; accountNumber?: string; configIds?: string[] }) => async (dispatch) => {
    if (!parameters?.dpIds) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { settingRouterConfigVisibility: true } });
    try {
        let res = await api.starlink.put('/router-config/visibility', parameters, {})
         handleResponseObj(res, dispatch, ACTION_TYPES.SET_ROUTER_CONFIG_VISIBILITY)
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { settingRouterConfigVisibility: false } });
         showToastMessage(res, 'Router Config visiblity Updated successfully.')
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { settingRouterConfigVisibility: false } });
        return error;
    }
}